import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navigation from './components/Navigation';
import BookBand from './components/BookBand';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

import HomePage from './pages/HomePage';
import HowWeHelpPage from './pages/HowWeHelpPage';
import FrameworksPage from './pages/FrameworksPage';
import ArgumentPage from './pages/ArgumentPage';
import BookPage from './pages/BookPage';
import ThoughtLeadershipPage from './pages/ThoughtLeadershipPage';
import WhyWeExistPage from './pages/WhyWeExistPage';
import ContactPage from './pages/ContactPage';
import PrivacyPage from './pages/PrivacyPage';
import SimulatorNoticePage from './pages/SimulatorNoticePage';
import DiagnosticPage from './pages/DiagnosticPage';
import NotFoundPage from './pages/NotFoundPage';

/**
 * Routes, version 2. Seven pages, the Compass, the contact page, and
 * redirects for every route the first site ever published, so nothing
 * shared on LinkedIn dies.
 */

const R = (to) => <Navigate to={to} replace />;

function App() {
  return (
    <Router>
      <ScrollToTop />
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] bg-white text-navy-800 px-3 py-2 rounded-sm">Skip to content</a>
      <BookBand />
      <Navigation />
      <main id="main">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/why-it-matters" element={<ArgumentPage />} />
          <Route path="/what-we-do" element={<HowWeHelpPage />} />
          <Route path="/what-we-think" element={<ThoughtLeadershipPage />} />
          <Route path="/who-we-are" element={<WhyWeExistPage />} />
          <Route path="/frameworks" element={<FrameworksPage />} />
          <Route path="/compass" element={<DiagnosticPage />} />
          <Route path="/book" element={<BookPage />} />

          {/* Children of the pillars, as clean addresses */}
          <Route path="/why-it-matters/cognitive-atrophy" element={R('/why-it-matters#cognitive-atrophy')} />
          <Route path="/why-it-matters/ai-fluency" element={R('/why-it-matters#ai-fluency')} />
          <Route path="/what-we-do/advisory" element={R('/what-we-do#advisory')} />
          <Route path="/what-we-do/osu-fisher" element={R('/what-we-do#osu-fisher')} />
          <Route path="/what-we-do/apprenticeship" element={R('/what-we-do#apprenticeship')} />
          <Route path="/what-we-think/substack" element={R('/what-we-think#substack')} />
          <Route path="/what-we-think/articles" element={R('/what-we-think#articles')} />

          {/* Earlier version 2 addresses */}
          <Route path="/why" element={R('/why-it-matters')} />
          <Route path="/the-argument" element={R('/why-it-matters')} />
          <Route path="/the-argument/*" element={R('/why-it-matters')} />
          <Route path="/how-we-help" element={R('/what-we-do')} />
          <Route path="/how-we-help/*" element={R('/what-we-do')} />
          <Route path="/writing" element={R('/what-we-think')} />
          <Route path="/thought-leadership" element={R('/what-we-think')} />
          <Route path="/thought-leadership/*" element={R('/what-we-think')} />
          <Route path="/about" element={R('/who-we-are')} />
          <Route path="/why-we-exist" element={R('/who-we-are')} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/simulator" element={<SimulatorNoticePage />} />
          <Route path="/simulator/*" element={<SimulatorNoticePage />} />

          {/* First-site routes */}
          <Route path="/who" element={R('/who-we-are')} />
          <Route path="/who/*" element={R('/who-we-are')} />
          <Route path="/how" element={R('/why-it-matters')} />
          <Route path="/how/*" element={R('/why-it-matters')} />
          <Route path="/what" element={R('/what-we-do')} />
          <Route path="/what/frameworks" element={R('/frameworks')} />
          <Route path="/what/*" element={R('/what-we-do')} />
          <Route path="/why/*" element={R('/why-it-matters')} />
          <Route path="/thought" element={R('/what-we-think')} />
          <Route path="/thought/*" element={R('/what-we-think')} />
          <Route path="/guide" element={R('/book')} />
          <Route path="/services" element={R('/what-we-do')} />
          <Route path="/ai-fluency" element={R('/why-it-matters#ai-fluency')} />
          <Route path="/ai-fluency-levels" element={R('/compass#ladder')} />
          <Route path="/cothink-method" element={R('/what-we-do')} />
          <Route path="/learning-path" element={R('/why-it-matters')} />
          <Route path="/compass-info" element={R('/compass')} />
          <Route path="/diagnostic" element={R('/compass')} />
          <Route path="/index.html" element={R('/')} />

          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      <Footer />
    </Router>
  );
}

export default App;
